import { useState, useEffect } from 'react';

export function useProgress(key) {
  const [completedItems, setCompletedItems] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.warn('Error reading localStorage', error);
      return [];
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(completedItems));
    } catch (error) {
      console.warn('Error setting localStorage', error);
    }
  }, [key, completedItems]);

  const toggleCompleted = (id) => {
    setCompletedItems(prev => 
      prev.includes(id) ? prev.filter(itemId => itemId !== id) : [...prev, id]
    );
  };

  const isCompleted = (id) => completedItems.includes(id);

  return { completedItems, toggleCompleted, isCompleted };
}
